import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Subscription } from 'rxjs';
import { CreateCampaignLogicService } from '../../../services/create-campaign-logic.service';
import { GroupLabelsComponent } from '../group-labels/group-labels.component';
import { Label } from 'src/app/models';
import { MakingWavesLoaderService } from 'src/app/modules/shared/services';

@Component({
    selector: 'labels-dialog',
    templateUrl: 'labels-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, MatButtonModule, GroupLabelsComponent]
})
export class LabelsDialogContentDialog {
  private groupsSub?: Subscription;
  selectedLabels: Label[] = [];   // store the selection
  groups: string[] = [];

  constructor(
    private createCampaignService: CreateCampaignLogicService,
    private dialogRef: MatDialogRef<LabelsDialogContentDialog>,
    private loaderService: MakingWavesLoaderService,
  ) {}

  // just keep track of selected labels, no API call here
  onSelectionChange(labels: Label[]) {
    this.selectedLabels = labels;
  }

  onSave() {
    if (!this.selectedLabels.length) {
      this.dialogRef.close({ groups: [] });
      return;
    }

    this.loaderService.showLoader();

    // fetch groups once at save
    this.groupsSub = this.createCampaignService
      .getGroupsByLabelIds(this.selectedLabels.map(l => l.id))
      .subscribe({
        next: (groups: { GroupUser: string; Restrictions: string }[]) => {
          this.groups = groups.map(g => g.GroupUser);
          this.loaderService.hideLoader();
          this.dialogRef.close({
            selectedLabels: this.selectedLabels.map(l => l.name),
            groups: this.groups,
          });
        },
        error: (err) => {
          console.error(err);
          this.loaderService.hideLoader();
          this.dialogRef.close({ selectedLabels: [], groups: [] });
        },
      });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
